
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import SignUpForm from '@/components/Auth/Signup/SignUpForm.vue';
  import Welcome from '@/components/Auth/Signup/Welcome.vue';

  @Component({
    components: {
      Welcome,
      SignUpForm,
    },
  })
  export default class RegisterPage extends Vue {
    success: boolean = false;

    onSuccess() {
      this.success = true;
    }
  }

